import { TimePicker as AntTimePicker, type TimePickerProps } from 'antd';

export const TimePicker = ({ ...props }: TimePickerProps) => {
  return <AntTimePicker size="large" format="HH:mm" {...props} />;
};
